import { NewWaybillModalComponent } from './waybill/new-waybill/newWaybillModal.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { systemRoutes } from './system.routes';
import { NotifierComponent } from './shared/notifier/notifier.component';
import { NotifierService } from './shared/notifier/notifier.service';
import { SystemComponent } from './system.component';
import { HttpModule } from '@angular/http';
import { CoreModule } from './core';
import { SharedModule } from '../shared';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { AuthGuard } from './shared/auth.guard';
import { AlertComponent } from './shared/alerts/alert.component';
import { AutoCompleterService } from './shared/autocomplete/autocomplete.service';
import { ApprobationService } from './services/approbation.service';
import { NvD3Module } from 'ng2-nvd3';
import 'chart.js';
import 'd3';
import 'nvd3';
import { ChartsModule } from 'ng2-charts';
import { WorkOrderComponent } from './work-order/work-order.component';
import { NewWorkOrderComponent } from './work-order/new-work-order/new-work-order.component';
import { WorkOrderListComponent } from './work-order/work-order-list/work-order-list.component';
import { InternalWorkOrderComponent } from './work-order/internal-work-order/internal-work-order.component';
import { BudgetComponent } from './budget/budget.component';
import { NewBudgetComponent } from './budget/new-budget/new-budget.component';
import { CreateBudgetModalComponent } from './budget/new-budget/createBudgetModal/createBudgetModal.component';
import { BudgetListComponent } from './budget/budget-list/budget-list.component.';
import { BillingComponent } from './billing/billing.component';
import { NewBillingComponent } from './billing/new-billing/new-billing.component';
import { BillingListComponent } from './billing/billing-list/billing-list.component';
import { ApprobationGroupComponent } from './approbation-group/approbation-group.component';
import { ApprobationGroupDetailComponent } from './approbation-group/approbation-group-detail/approbation-group-detail.component';
import { RejectBudgetModalComponent } from './budget/reject-budget-modal/reject-budget-modal.component';
import { BillSpecificComponent } from './billing/bill-specific/bill-specific.component';
import { InternalService } from './services/internal.service';
import { ProviderComponent } from './provider/provider.component';
import { EditarProviderModalComponent } from './provider/modals/editProvider/editProviderModal.component';
import { BuyOrderComponent } from './buy-order/buy-order.component';
import { NewBuyOrderComponent} from './buy-order/new-buy-order/new-buy-order.component';
import { BuyOrderListComponent } from './buy-order/buy-order-list/buy-order-list.component';
import { CreateBuyOrderModalComponent} from './buy-order/new-buy-order/createBuyOrderModal/createBuyOrderModal.component';

import { RetentionComponent } from './retention/retention.component';
import { NewRetentionComponent} from './retention/new-retention/new-retention.component';
import { RetentionListComponent } from './retention/retention-list/retention-list.component';
import { CreateRetentionModalComponent} from './retention/new-retention/createRetentionModal/createRetentionModal.component';



import { OcBudgetModalComponent } from './budget/new-budget/ocBudgetModal/ocBudgetModal.component';
import { DiscountModalComponent} from './billing/new-billing/modal/discountModal.component';
import { AppService } from './billing/new-billing/app.service';
import { DomChangeDirective } from './billing/new-billing/dom-change.directive';
import { AssignDiscountModalComponent } from './billing/new-billing/modal/assignDiscountModal.component';
import { WaybillComponent } from './waybill/waybill.component';
import { WaybillListComponent } from './waybill/waybill-list/waybill-list.component';
import { SpecificWaybillModalComponent } from './waybill/specific-waybill-modal/specific-waybill-modal.component';
import { ReportBillingDetailComponent } from './billing/report-billing-detail/report-billing-detail.component';
import { RegisterPieceDialogComponent } from './work-order/register-piece-dialog/register-piece-dialog.component';
import { ReportPieceDialogComponent } from './work-order/report-piece-dialog/report-piece-dialog.component';
import { ReportClientPieceDialogComponent } from './work-order/report-client-piece-dialog/report-client-piece-dialog.component';
import { ReportFullPieceOtDialogComponent } from './work-order/report-full-piece-ot-dialog/report-full-piece-ot-dialog.component';
import { ListofvaluesService } from './services/listofvalues.service';
import { CreateGlobalDiscountComponent } from './budget/new-budget/create-global-discount/create-global-discount.component';




@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(systemRoutes),
    FormsModule,
    HttpClientModule,
    HttpModule,
    CoreModule,
    SharedModule,
    Ng2SmartTableModule,
    NvD3Module,
    ChartsModule
  ],
  declarations:
    [
      SystemComponent,
      NotifierComponent,
      AlertComponent,
      WorkOrderComponent,
      NewWorkOrderComponent,
      WorkOrderListComponent,
      InternalWorkOrderComponent,
      BudgetComponent,
      NewBudgetComponent,
      BudgetListComponent,
      CreateBudgetModalComponent,
      BillingComponent,
      NewBillingComponent,
      BillingListComponent,
      ApprobationGroupComponent,
      ApprobationGroupDetailComponent,
      RejectBudgetModalComponent,
      BillSpecificComponent,
      ProviderComponent,
      EditarProviderModalComponent,
      BuyOrderComponent,
      NewBuyOrderComponent,
      BuyOrderListComponent,
      CreateBuyOrderModalComponent,

      RetentionComponent,
      NewRetentionComponent,
      RetentionListComponent,
      CreateRetentionModalComponent,

      OcBudgetModalComponent,
      DiscountModalComponent,
      DomChangeDirective,
      AssignDiscountModalComponent,
      WaybillComponent,
      WaybillListComponent,
      NewWaybillModalComponent,
      SpecificWaybillModalComponent,
      ReportBillingDetailComponent,
      RegisterPieceDialogComponent,
      ReportPieceDialogComponent,
      ReportClientPieceDialogComponent,
      ReportFullPieceOtDialogComponent,
      CreateGlobalDiscountComponent,
    ],
  exports: [
    NotifierComponent
  ],
  providers: [
    NotifierService,
    AuthGuard,
    AutoCompleterService,
    ApprobationService,
    InternalService,
    ListofvaluesService,
    AppService
  ],
  entryComponents: [
    AlertComponent,
    CreateBudgetModalComponent,
    RejectBudgetModalComponent,
    EditarProviderModalComponent,
    CreateBuyOrderModalComponent,
    CreateRetentionModalComponent,
    OcBudgetModalComponent,
    DiscountModalComponent,
    AssignDiscountModalComponent,
    NewWaybillModalComponent,
    SpecificWaybillModalComponent,
    ReportBillingDetailComponent,
    RegisterPieceDialogComponent,
    ReportPieceDialogComponent,
    ReportClientPieceDialogComponent,
    ReportFullPieceOtDialogComponent,
    CreateGlobalDiscountComponent
  ]
})
export class SystemModule { }



// WEBPACK FOOTER //
// ./src/app/system/system.module.ts